import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { CodeBlock } from '../CodeBlock';
import { Section, TextLink, monoSm } from './Section';
import { SURFACES } from './copy';

const HEADING_ID = 'surfaces-title';

function Column({
  title,
  code,
  caption,
  children,
}: {
  title: string;
  code: string;
  caption: string;
  children?: ReactNode;
}) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="h4" component="h3">
        {title}
      </Typography>
      <Box sx={{ mb: 1 }}>
        <CodeBlock code={code} language="bash" />
      </Box>
      <Typography component="p" sx={{ ...monoSm, maxWidth: '60ch' }}>
        {caption}
      </Typography>
      {children}
    </Box>
  );
}

export function AnalystsAgents() {
  return (
    <Section labelledBy={HEADING_ID} title={SURFACES.title} titleMaxWidth="28ch">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
          columnGap: 6,
          rowGap: 5,
          alignItems: 'start',
        }}
      >
        <Column
          title={SURFACES.stack.title}
          code={SURFACES.stack.code}
          caption={SURFACES.stack.caption}
        />
        <Column
          title={SURFACES.agent.title}
          code={SURFACES.agent.code}
          caption={SURFACES.agent.caption}
        >
          <TextLink
            to={SURFACES.agent.link.to}
            sx={{ display: 'inline-block', mt: 2, fontSize: '0.875rem' }}
          >
            {SURFACES.agent.link.label}
          </TextLink>
        </Column>
      </Box>
    </Section>
  );
}
